console.log('Cursor dot script loaded');

(function () {
  const dot = document.createElement('div');
  dot.id = 'cursor-dot';

  Object.assign(dot.style, {
    position: 'fixed',
    width: '6px',
    height: '6px',
    background: 'red',
    borderRadius: '50%',
    pointerEvents: 'none',
    zIndex: '2147483647',
    left: '0px',
    top: '0px',
    transform: 'translate(-50%, -50%)'
  });

  document.documentElement.appendChild(dot);

  let mouseX = 0, mouseY = 0;
  let dotX = 0, dotY = 0;

  window.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  function animate() {
    dotX += (mouseX - dotX) * 0.15;
    dotY += (mouseY - dotY) * 0.15;

    dot.style.left = dotX + 'px';
    dot.style.top = dotY + 'px';

    requestAnimationFrame(animate);
  }

  animate();
})();
